import { defineMiniApp } from '../../registry';

import { ClinicalTasksPanel } from './ClinicalTasksPanel';
import { CLINICAL_TASKS_AGENT_ID } from './constants';
import { toggleTasksPanel } from './tasks-panel-store';
import { useTasksActionState } from './useTasksActionState';

/**
 * Clinical-tasks mini-app (ENG-5218/ENG-5223): AI-extracted follow-up actions
 * (draft FHIR Tasks) reviewed and tracked in the summary side column.
 * Extraction runs automatically once the visit's full transcript lands,
 * transcript-only, in parallel with note generation (the agent's
 * `transcript-available` trigger → `run_mini_app_agent`), so the panel is
 * review + Todo/Done
 * only — no manual trigger, no install/consent. Self-contained: the summary
 * screen only renders `<MiniAppPanels slot=… />` / `<MiniAppActions slot=… />`.
 *
 * The `appointment-session` slot contributes ONLY the Tasks action button
 * (spinner while the extraction job runs → count once it settles; click
 * toggles the panel). The panel itself is registered on the side-column slot
 * alone — a second panel slot would double-mount its poller.
 */
export const clinicalTasksApp = defineMiniApp({
  id: CLINICAL_TASKS_AGENT_ID,
  identity: {
    displayName: 'Clinical Tasks',
    publisher: 'Eluve',
    trustLevel: 'first-party',
  },
  slots: ['appointment-session', 'appointment-summary-side'],
  panel: {
    visible: (ctx) => Boolean(ctx.appointmentId),
    component: ClinicalTasksPanel,
  },
  action: {
    label: 'Tasks',
    visible: (ctx) => Boolean(ctx.appointmentId),
    onClick: () => toggleTasksPanel(),
  },
  useActionState: useTasksActionState,
});
